import type { JSX } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './frame/Layout';
import { PersonnelPage } from './modules/personnel/PersonnelPage';
import { IdentityPage } from './modules/identity/IdentityPage';
import { ApprovalPage } from './modules/access/ApprovalPage';
import { PrivacyPage } from './modules/legal/PrivacyPage';
import { ParishesSignIn } from './modules/auth/ParishesSignIn';
import { LogoutPage } from './modules/auth/LogoutPage';
import { SurveyPage } from './modules/health/survey/SurveyPage';
import { HealthLayout } from './modules/health/HealthLayout';
import { CycleListPage } from './modules/health/CycleListPage';
import { NewCyclePage } from './modules/health/NewCyclePage';
import { GuidePage } from './modules/health/GuidePage';
import { CyclePage } from './modules/health/CyclePage';
import { AdminSettingsPage } from './modules/health/AdminSettingsPage';
import { CrossChurchPage } from './modules/health/CrossChurchPage';
import { InstrumentEditorPage } from './modules/health/instrument/InstrumentEditorPage';
import { CyclePreviewPage } from './modules/health/CyclePreviewPage';

export function App(): JSX.Element {
  return (
    <Routes>
      {/* Stand-alone pages: no parish frame. The shared <LoginScreen> (ParishesSignIn)
          owns both the email and code steps, so there is no separate /auth/verify. */}
      <Route path="auth/login" element={<ParishesSignIn />} />
      <Route path="auth/logout" element={<LogoutPage />} />
      <Route path="access/approve/:token" element={<ApprovalPage />} />
      <Route path="privacy" element={<PrivacyPage />} />
      {/* Church Health Assessment: public respondent survey (token-gated, no auth). */}
      <Route path="health/:token" element={<SurveyPage />} />
      {/* Church Health Assessment portal area. Deliberately outside the parish
          Layout: external facilitators are scoped to health only (nav isolation). */}
      <Route path="portal/health" element={<HealthLayout />}>
        <Route index element={<CycleListPage />} />
        <Route path="admin/settings" element={<AdminSettingsPage />} />
        <Route path="admin/overview" element={<CrossChurchPage />} />
        {/* Literal admin paths must precede the :cycleId param route. */}
        <Route path="admin/instrument" element={<InstrumentEditorPage />} />
        <Route path="new" element={<NewCyclePage />} />
        <Route path="guide" element={<GuidePage />} />
        {/* Survey preview opens in its own window from the cycle page. */}
        <Route path=":cycleId/preview" element={<CyclePreviewPage />} />
        <Route path=":cycleId" element={<CyclePage />} />
      </Route>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="identity" replace />} />
        <Route path="parish/:parishId/identity" element={<IdentityPage />} />
        <Route path="parish/:parishId/personnel" element={<PersonnelPage />} />
        <Route path="identity" element={<IdentityPage />} />
        <Route path="personnel" element={<PersonnelPage />} />
      </Route>
    </Routes>
  );
}
